import { useCallback, useEffect } from 'react';
import { AppBroadcastChannel, AppBroadcastEvents } from '../global';

export function useAppBroadcastPublisher(chanel: AppBroadcastChannel = AppBroadcastChannel.AppChannel) {
  useEffect(() => {
    const channel = new BroadcastChannel(chanel);

    channel.onmessage = event => {
      if (event.data?.type === AppBroadcastEvents.PAGE_RELOAD) {
        window.location.href = `/`;
      }
    };

    return () => channel.close();
  }, [chanel]);

  const handlePublishEvent = useCallback(
    (event: AppBroadcastEvents) => {
      const channel = new BroadcastChannel(chanel);
      channel.postMessage({ type: event });
      channel.close();
    },
    [chanel]
  );

  return { handlePublishEvent };
}
